import { Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RowMenuItem } from "./row_menu";

export type ShowAllBookingsAction = {
  isEnabled: boolean;
  onClick: VoidFunction;
};

interface UseRowMenuShowInTabOption {
  row: Row;
  showAllBookingsAction: ShowAllBookingsAction;
}

export const useRowMenuShowAllBookings = ({
  row,
  showAllBookingsAction
}: UseRowMenuShowInTabOption): RowMenuItem => {
  const { isEnabled, onClick } = showAllBookingsAction;
  const { type } = row;
  const { t } = useTranslation("bookingModule", { keyPrefix: "projects.rowMenu.showAllBookingsMode" });

  const label = useMemo<string>(() => {
    if (isEnabled) {
      return type === RowType.Profile ? t("active.profile") : t("active.project");
    } else {
      return type === RowType.Profile ? t("inactive.profile") : t("inactive.project");
    }
  }, [isEnabled, type, t]);

  return {
    id: "allBookingsMode",
    label,
    icon: isEnabled ? "hidden" : "shown",
    item: onClick
  };
};
